/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { GpChildProduct } from '@/app/editor/iframe/atom/module/GpChildProduct';
import type { AtomModel, FormControlSetting, Font } from '@/app/editor/iframe/atom/Atom.model';
import HELPER from '@/app/utils/HELPER';
import pVariantsInfor from '@/app/editor/sidebar/module/pVariants';
import GpChildProductExportService from '@/app/editor/iframe/atom/atom-service/export/GpChildProductExportService';
import type { AtomExportInterface } from '@/app/editor/iframe/atom/atom-interface/AtomExportInterface';

/**
 * GpPVariantsChildProductExportService
 */
export class GpPVariantsChildProductExportService extends GpChildProductExportService {
  /**
   * cloneAtom
   * @override GpChildProductExportService.cloneAtom
   * @param $atomClone :jQuery
   * @param templateTmp :string
   * @returns $atomClone
   */
  cloneAtom($atomClone: JQuery, templateTmp: string): JQuery {
    const matchedString = new RegExp('product.options', 'g');
    templateTmp = templateTmp.replace(matchedString, 'product.options_with_values');
    return $atomClone.html(templateTmp);
  }
}

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'css',
    name: 'label-bottom',
    default_value: '5px',
    targetSelector: 'label',
    property: 'padding-bottom',
    require: true,
    selfSelector: '-1,1', // Dùng $self cho `saveFormControls`: 1 không sử dụng cho `readDataFormControls`: -1
  },
  {
    type: 'css',
    name: 'label-font-size',
    default_value: '16px',
    targetSelector: 'label',
    property: 'font-size',
    require: true,
    selfSelector: '-1,1',
  },
  {
    type: 'css',
    name: 'label-line-height',
    default_value: '1.2em',
    targetSelector: 'label',
    property: 'line-height',
    unit: 'em',
    require: true,
    selfSelector: '-1,1',
  },
  {
    type: 'css',
    name: 'label-color',
    default_value: '#2d313f',
    targetSelector: 'label',
    property: 'color',
    fieldType: 'color',
    require: true,
    selfSelector: '-1,1',
  },
  {
    type: 'css',
    name: 'label-font',
    default_value: '',
    targetSelector: 'label',
    property: 'font-family',
    require: true,
    selfSelector: '-1,1',
  },
  {
    type: 'css',
    name: 'inlineSpacing',
    default_value: '100px',
    targetSelector: 'label',
    property: 'min-width',
    selfSelector: '1,1',
  },
  {
    type: 'css:notSelector',
    name: 'width',
    default_value: 'auto',
    property: 'width',
    selfSelector: '1,1',
  },
  {
    type: 'css:notSelector',
    name: 'height',
    default_value: '44px',
    property: 'height',
    require: true,
    selfSelector: '1,1',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.elm',
    property: 'data-exc',
  },
];
/**
 * Hero Banner Atom Module
 */
export class GpPVariants extends GpChildProduct {
  public $el: JQuery;
  public atomServiceExportData: AtomExportInterface;
  /**
   * Thông tin riêng của Atom
   * @returns object watch
   */
  getDataAtom(): AtomModel {
    const data: AtomModel = {
      type: this.getType(),
      id: this.getId(),
      nodeId: this.getIdNode(),
      name: this.getLabel(),
      slug: this.getSlug(),
      groupName: this.getGroupName(),
      settings: this.getSettings(),
      formControlSettings: FormControlSettings,
      data: this.getDataChilds(),
      html: this.getTemplate(),
      class: this.getTargetClassSelector(), //".gf_variants",
      style: this.getStyle(),
      script: this.getScript(),
      libs: this.getLibs(),
      fonts: [] as Array<Font>,
      version: 1,
    };
    return data;
  }

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || '(P) Swatches';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'p-swatches';
  }
  /**
   * GetModuleId
   * @returns number
   */
  getModuleId() {
    let moduleId = HELPER.MakeIdInsideList(this.$el);
    if (moduleId == '') {
      moduleId = this.$el.attr('data-id') || HELPER.MakeId().toString();
    }

    return moduleId;
  }

  /**
   * get Data from html attr
   * @returns Group Name
   */
  getGroupName(): string {
    return this.$el.attr('data-groupname') || 'Module';
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }

  /**
   * getTargetClass
   * @returns Class name of module
   */
  getTargetClassSelector(): string {
    return '.' + pVariantsInfor.class;
  }
  /**
   * getTargetWrap
   * @returns Class name of module
   */
  getTargetWrapSelector(): string {
    return '.' + pVariantsInfor.wrap;
  }

  /**
   * @override Atom.initAtomExport
   */
  initAtomExport() {
    this.atomServiceExportData = new GpPVariantsChildProductExportService(this);
  }
}
